import React, { useState } from "react"
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar"
import { AppSidebar } from "@/components/layout/app-sidebar"
import { MobileNav } from "@/components/layout/mobile-nav"
import { UserNav } from "@/components/layout/user-nav"
import { ModeToggle } from "@/components/mode-toggle"
import { Button } from "@/components/ui/button"
import { Bell } from "lucide-react"
import { ImpersonationBanner } from "@/components/impersonation-banner"
import { GlobalSearch } from "@/components/global-search"
import { QuickActionsMenu } from "@/components/layout/quick-actions-menu"

export function AuthenticatedLayout({ children }) {
  const [isSearchExpanded, setIsSearchExpanded] = useState(false)

  return (
    <SidebarProvider>
      <div className="flex min-h-screen flex-col w-full">
        <header className="sticky top-0 z-40 border-b bg-background w-full">
          <div className="flex h-16 w-full items-center justify-between px-4 md:px-6">
            <div className="flex items-center gap-2">
              <SidebarTrigger className="md:hidden" />
              <a href="/" className="text-xl font-bold">
                DME
              </a>
            </div>
            <div className="flex items-center gap-3">
              {/* Global Search - right aligned */}
              <GlobalSearch onExpandChange={setIsSearchExpanded} />
              {/* Hide quick actions, theme toggle and user nav on mobile when search is expanded */}
              <div className={isSearchExpanded ? "hidden md:block" : ""}>
                <QuickActionsMenu />
              </div>
              <div className={isSearchExpanded ? "hidden md:block" : ""}>
                <ModeToggle />
              </div>
              <div className={isSearchExpanded ? "hidden md:block" : ""}>
                <UserNav />
              </div>
            </div>
          </div>
        </header>
        <div className="flex flex-1 w-full">
          <AppSidebar />
            <main className="flex-1 w-full p-0 overflow-x-auto">            
              <ImpersonationBanner />
              {children}
            </main>
        </div>
        <MobileNav />
      </div>
    </SidebarProvider>
  )
} 